export class Cron {
    minute: string;
    hour: string;
    date: string;
    month: string;
    weekday: string;
    weeknum: string;

    constructor(min: string, hr: string, day: string, mon: string, wday: string, wnum: string) {
        this.minute = min;
        this.hour = hr;
        this.date = day;
        this.month = mon;
        this.weekday = wday;
        this.weeknum = wnum;
    }

    public toString() {
        return `${parseInt(this.minute)} ${parseInt(this.hour)} * * ${this.weekday}#${this.weeknum}`;
    }

    public static parse(cronStr: string): Cron {
        var splits = cronStr.split(" ");
        var min = splits[0];
        var hr = splits[1];
        var day = splits[2];
        var mon = splits[3];
        var wday = splits[4].split("#")[0];
        var wnum = splits[4].split("#")[1];
        return new Cron(min, hr, day, mon, wday, wnum);
    }

    getNextDate(): Date {
        let next: Date = new Date();
        while (true) {
            if (this.month != "*" && parseInt(this.month) != next.getMonth()) {
                // month is always * in our case
            }
            if (this.date != "*" && parseInt(this.date) != next.getDate()) {
                // date is always * in our case
            }
            if (this.weekday != '*' && next.getDay() != parseInt(this.weekday)) {
                next.setDate(next.getDate() + 1);
                next.setHours(0);
                next.setMinutes(0);
                continue;
            }
            if (this.weeknum != '*' && this.getWeekNumber(next) != parseInt(this.weeknum)) {
                next.setDate(next.getDate() + 1);
                next.setHours(0);
                next.setMinutes(0);
                continue;
            }
            if (this.hour != '*' && next.getHours() != parseInt(this.hour)) {
                next.setHours(next.getHours() + 1);
                next.setMinutes(0);
                continue;
            }
            if (this.minute != '*' && next.getMinutes() != parseInt(this.minute)) {
                next.setMinutes(next.getMinutes() + 1);
                continue;
            }
            break;
        }
        return next;
    }

    private getWeekNumber(date: Date){
        return (Math.floor(date.getDate() / 7)) + 1;
    }
    // firstMonday(month, year) {
    //     var d = new Date(year, month, 1, 0, 0, 0, 0)
    //     var day = 0
    //     // check if first of the month is a Sunday, if so set date to the second
    //     if (d.getDay() == 0) {
    //         day = 2
    //         d = d.setDate(day)
    //         d = new Date(d)
    //     }
    //     // check if first of the month is a Monday, if so return the date, otherwise get to the Monday following the first of the month
    //     else if (d.getDay() != 1) {
    //         day = 9 - (d.getDay())
    //         d = d.setDate(day)
    //         d = new Date(d)
    //     }
    //     return d
    // }

}